<button *ngIf="!active" class="fixed bottom-4 right-4 text-white px-2 py-1 rounded-full z-50 flex items-center justify-center bg-greenBTP hover:bg-greenBTP-dark" (click)="toggleChat()">
  <img src="assets/images/chat.png" alt="Chat" class="w-12 h-12">
</button>
<!-- Chatbox Container -->
<div *ngIf="active" class="chatbox-container bg-white shadow-md rounded-lg overflow-hidden transition duration-250 absolute bottom-8 right-8 w-96 h-2/3 z-10">
  <!-- Header -->
  <div style="background-color: #00786f" class="text-white p-4 text-lg font-bold flex items-center justify-between">
    <span>
      <fa-icon [icon]="faRobot" class="mr-2"></fa-icon>
      LineUp Pro AI
    </span>
    <button class="ml-auto" (click)="closeChat()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Conversation -->
  <div class="flex flex-col flex-auto border-l overflow-hidden bg-gray-50 dark:bg-transparent">
    <ng-container *ngIf="chat">
      <div class="flex flex-col-reverse overflow-y-auto overscroll-y-contain h-full">
        <div class="flex flex-col flex-auto shrink p-6">
          <ng-container *ngFor="let message of chat.messages; let i = index; let first = first; let last = last; trackBy: trackByFn">
            <!-- Start of the day -->
            <ng-container *ngIf="first || (chat.messages[i - 1].createdAt | date:'d') !== (message.createdAt | date:'d')">
              <div class="flex items-center justify-center my-3 -mx-6">
                <div class="flex-auto border-b"></div>
                <div class="flex-0 mx-4 text-sm font-medium leading-5 text-secondary">
                  {{message.createdAt | date: 'longDate'}}
                </div>
                <div class="flex-auto border-b"></div>
              </div>
            </ng-container>
            <div class="flex flex-col" [ngClass]="{'items-end': message.isMine, 'items-start': !message.isMine, 'mt-0.5': i > 0 && chat.messages[i - 1].isMine === message.isMine, 'mt-3': i > 0 && chat.messages[i - 1].isMine !== message.isMine}">
              <!-- Bubble -->
              <div class="relative max-w-3/4 px-3 py-2 rounded-lg" [ngClass]="{'bg-blue-500 text-blue-50': message.isMine, 'bg-gray-500 text-gray-50': !message.isMine}">
                <!-- Speech bubble tail -->
                <ng-container *ngIf="last || chat.messages[i + 1].isMine !== message.isMine">
                  <div class="absolute bottom-0 w-3" [ngClass]="{'text-blue-500 -right-1 -mr-px mb-px': message.isMine, 'text-gray-500 -left-1 -ml-px mb-px -scale-x-1': !message.isMine}">
                    <ng-container *ngTemplateOutlet="speechBubbleExtension"></ng-container>
                  </div>
                </ng-container>
                <!-- Message -->
                <div class="min-w-4 leading-5" [innerHTML]="message.value"></div>
              </div>
              <!-- Time -->
              <ng-container *ngIf="first || last || chat.messages[i + 1].isMine !== message.isMine || chat.messages[i + 1].createdAt !== message.createdAt">
                <div class="my-0.5 text-sm font-medium text-secondary" [ngClass]="{'mr-3': message.isMine, 'ml-3': !message.isMine}">
                  {{message.createdAt | date:'HH:mm'}}
                </div>
              </ng-container>
            </div>
          </ng-container>

          <!-- AI is typing message -->
          <div *ngIf="isTyping" class="typing-indicator">
            <mat-hint class="typing-text">AI is typing...</mat-hint>
          </div>
        </div>
      </div>

      <!-- Message field -->
      <div class="flex items-end p-4 border-t bg-gray-50 dark:bg-transparent">
        <mat-form-field class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full" [subscriptSizing]="'dynamic'">
          <textarea (keydown.enter)="sendMessage($event)" matInput cdkTextareaAutosize #messageInput></textarea>
        </mat-form-field>
        <div class="flex items-center h-11 my-px ml-4">
          <button (click)="sendMessage($event)" mat-icon-button>
            <mat-icon class="rotate-90" [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
